function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

/* =========================
   PROMO + GIFT LOGIC
========================= */

const PROMO_COLLECTION =  [];
const PROMO_CODES = ['3items', '4items', '5items'];
const PROMO_RELOAD_KEY = 'promo_sync_reload_once';
const GIFT_POPUP_DISMISSED_KEY = 'gift_popup_dismissed';

// const PROMO_COLLECTION = window.volumePromoProducts || [];
// const PROMO_CODES = ['3items', '4items', '5items'];
// const PROMO_RELOAD_KEY = 'promo_sync_reload_once';
// const GIFT_POPUP_DISMISSED_KEY = 'gift_popup_dismissed';


let promoEngineRunning = false;
let promoSyncTimer = null;

function isCartPage() {
  return window.location.pathname === '/cart';
}

async function getCart() {
  const res = await fetch(window.Shopify.routes.root + 'cart.js', {
    credentials: 'same-origin'
  });

  if (!res.ok) {
    throw new Error(`Failed to load cart: ${res.status}`);
  }

  return await res.json();
}

function countPromoProducts(cart) {
  let count = 0;

  cart.items.forEach((item) => {
    if (PROMO_COLLECTION.includes(item.product_id)) {
      count += item.quantity;
    }
  });

  return count;
}

function getTargetDiscountCode(promoQty) {
  if (promoQty >= 5) return '5items';
  if (promoQty >= 4) return '4items';
  if (promoQty >= 3) return '3items';
  return '';
}

function getAppliedDiscountCodes(cart) {
  if (!cart.discount_codes || !Array.isArray(cart.discount_codes)) return [];

  return cart.discount_codes
    .map((discount) => {
      if (typeof discount === 'string') return discount.toLowerCase();
      if (discount && discount.code) return String(discount.code).toLowerCase();
      return '';
    })
    .filter(Boolean);
}

function findGiftItem(cart) {
  return cart.items.find((item) => {
    return item.properties && item.properties._free_gift === 'true';
  });
}

async function clearPromoDiscounts() {
  const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      discount: ''
    })
  });

  if (!res.ok) {
    throw new Error(`Failed to clear discounts: ${res.status}`);
  }

  return await res.json();
}

async function applyDiscountCode(code) {
  const res = await fetch(
    window.Shopify.routes.root + `discount/${encodeURIComponent(code)}?redirect=/cart`,
    {
      credentials: 'same-origin'
    }
  );

  if (!res.ok) {
    throw new Error(`Failed to apply discount ${code}: ${res.status}`);
  }
}

async function removeGiftFromCart(cart) {
  const giftItem = findGiftItem(cart);
  if (!giftItem) return;

  const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      id: giftItem.key,
      quantity: 0
    })
  });

  if (!res.ok) {
    throw new Error(`Failed to remove free gift: ${res.status}`);
  }

  return await res.json();
}

function reloadPageOnce() {
  const reloadDone = sessionStorage.getItem(PROMO_RELOAD_KEY);

  if (reloadDone === '1') {
    sessionStorage.removeItem(PROMO_RELOAD_KEY);
    return;
  }

  sessionStorage.setItem(PROMO_RELOAD_KEY, '1');
  window.location.reload();
}

function clearReloadFlag() {
  sessionStorage.removeItem(PROMO_RELOAD_KEY);
}

function getGiftPopupOverlay() {
  return document.querySelector('#gift-popup-overlay');
}

function openGiftPopup() {
  const overlay = getGiftPopupOverlay();
  if (!overlay) return;
  if (!overlay.hidden) return;

  overlay.hidden = false;
  document.body.classList.add('overflow-hidden');
}

function closeGiftPopup(markDismissed = true) {
  const overlay = getGiftPopupOverlay();
  if (!overlay) return;

  overlay.hidden = true;
  document.body.classList.remove('overflow-hidden');

  if (markDismissed) {
    sessionStorage.setItem(GIFT_POPUP_DISMISSED_KEY, '1');
  }
}

function resetGiftPopupDismissed() {
  sessionStorage.removeItem(GIFT_POPUP_DISMISSED_KEY);
}

function isGiftPopupDismissed() {
  return sessionStorage.getItem(GIFT_POPUP_DISMISSED_KEY) === '1';
}

function initGiftPopup() {
  const overlay = getGiftPopupOverlay();
  if (!overlay) return;
  if (overlay.dataset.giftPopupInitialized === 'true') return;

  overlay.dataset.giftPopupInitialized = 'true';

  overlay.addEventListener('click', (event) => {
    if (
      event.target === overlay ||
      event.target.matches('[data-gift-popup-close]') ||
      event.target.closest('[data-gift-popup-close]')
    ) {
      closeGiftPopup(true);
    }
  });

  const variantsJsonEl = overlay.querySelector('[data-gift-variants-json]');
  const variantInput = overlay.querySelector('[data-gift-variant-id]');
  const optionSelects = overlay.querySelectorAll('.gift-popup-option');
  const mainImage = overlay.querySelector('[data-gift-main-image]');
  const form = overlay.querySelector('[data-gift-product-form]');
  const submitButton = overlay.querySelector('.gift-popup-submit');

  let variants = [];

  if (variantsJsonEl) {
    try {
      variants = JSON.parse(variantsJsonEl.textContent);
    } catch (error) {
      console.error('Gift variants parse error:', error);
    }
  }

  function getMatchedGiftVariant() {
    if (!variants.length) return null;

    const selectedOptions = Array.from(optionSelects).map((select) => select.value);

    return (
      variants.find((variant) => {
        return variant.options.every((optionValue, index) => optionValue === selectedOptions[index]);
      }) || null
    );
  }

  function updateSelectedGiftVariant() {
    const matchedVariant = getMatchedGiftVariant();
    if (!matchedVariant) return;

    if (variantInput) {
      variantInput.value = matchedVariant.id;
    }

    if (mainImage && matchedVariant.image) {
      mainImage.src = matchedVariant.image;
    }

    if (submitButton) {
      submitButton.disabled = !matchedVariant.available;
      submitButton.textContent = matchedVariant.available ? 'Add free gift' : 'Unavailable';
    }
  }

  optionSelects.forEach((select) => {
    select.addEventListener('change', updateSelectedGiftVariant);
  });

  updateSelectedGiftVariant();

  if (form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;

      try {
        if (submitButton) {
          submitButton.disabled = true;
        }

        const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              _free_gift: 'true',
              _promo_source: 'arcana-3plus'
            }
          })
        });

        if (!res.ok) {
          throw new Error(`Failed to add free gift: ${res.status}`);
        }

        closeGiftPopup(false);
        window.location.reload();
      } catch (error) {
        console.error('Add free gift error:', error);
        updateSelectedGiftVariant();
      }
    });
  }
}

async function syncPromotions() {
  if (!isCartPage()) return;
  if (promoEngineRunning) return;

  promoEngineRunning = true;

  try {
    const cart = await getCart();
    const promoQty = countPromoProducts(cart);
    const targetCode = getTargetDiscountCode(promoQty);
    const appliedCodes = getAppliedDiscountCodes(cart);
    const currentPromoCode = appliedCodes.find((code) => PROMO_CODES.includes(code)) || '';
    const giftItem = findGiftItem(cart);

    if (promoQty < 3) {
      resetGiftPopupDismissed();
      closeGiftPopup(false);

      let cartChanged = false;

      if (giftItem) {
        await removeGiftFromCart(cart);
        cartChanged = true;
      }

      if (currentPromoCode) {
        await clearPromoDiscounts();
        cartChanged = true;
      }

      if (cartChanged) {
        reloadPageOnce();
        return;
      }

      clearReloadFlag();
      return;
    }

    if (targetCode && currentPromoCode !== targetCode) {
      if (currentPromoCode) {
        await clearPromoDiscounts();
      }

      await applyDiscountCode(targetCode);
      reloadPageOnce();
      return;
    }

    clearReloadFlag();

    if (!giftItem && !isGiftPopupDismissed()) {
      setTimeout(() => {
        openGiftPopup();
      }, 300);
    } else if (giftItem) {
      closeGiftPopup(false);
    }
  } catch (error) {
    console.error('Promotion sync error:', error);
    clearReloadFlag();
  } finally {
    promoEngineRunning = false;
  }
}

function schedulePromotionSync(delay = 900) {
  if (!isCartPage()) return;

  clearTimeout(promoSyncTimer);
  promoSyncTimer = setTimeout(() => {
    syncPromotions();
  }, delay);
}

document.addEventListener('DOMContentLoaded', () => {
  initGiftPopup();

  if (isCartPage()) {
    syncPromotions();
  }

  document.body.addEventListener('change', (event) => {
    if (
      event.target.matches('input[name="updates[]"]') ||
      event.target.matches('.quantity__input')
    ) {
      if (isCartPage()) {
        schedulePromotionSync(1000);
      } else {
        scheduleSideCartPromotionSync(1000);
      }
    }
  });

  document.body.addEventListener('click', (event) => {
    const removeButton = event.target.closest(
      'cart-remove-button, [data-cart-remove], .cart_item_remove, .remove_button'
    );
    const qtyButton = event.target.closest('.quantity__button');
    const addToCartButton = event.target.closest(
      'button[name="add"], .product-form__submit, [data-add-to-cart]'
    );

    if (removeButton || qtyButton || addToCartButton) {
      if (isCartPage()) {
        schedulePromotionSync(1000);
      } else {
        scheduleSideCartPromotionSync(1200);
      }
    }
  });
});

async function refreshSideCart() {
  const currentSideCart = document.querySelector('#side-cart-content');
  if (!currentSideCart) return;

  try {
    const res = await fetch(window.Shopify.routes.root, {
      credentials: 'same-origin'
    });

    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newSideCart = doc.querySelector('#side-cart-content');

    if (newSideCart) {
      currentSideCart.replaceWith(newSideCart);
    }
  } catch (error) {
    console.error('Side cart refresh error:', error);
  }
}

async function syncPromotionsForSideCart() {
  if (isCartPage()) return;
  if (promoEngineRunning) return;

  promoEngineRunning = true;

  try {
    const cart = await getCart();
    const promoQty = countPromoProducts(cart);
    const targetCode = getTargetDiscountCode(promoQty);
    const appliedCodes = getAppliedDiscountCodes(cart);
    const currentPromoCode =
      appliedCodes.find((code) => PROMO_CODES.includes(code)) || '';
    const giftItem = findGiftItem(cart);

    let changed = false;

    if (promoQty < 3) {
      if (giftItem) {
        await removeGiftFromCart(cart);
        changed = true;
      }

      if (currentPromoCode) {
        await clearPromoDiscounts();
        changed = true;
      }
    } else if (targetCode && currentPromoCode !== targetCode) {
      if (currentPromoCode) {
        await clearPromoDiscounts();
      }

      await applyDiscountCode(targetCode);
      changed = true;
    }

    if (changed) {
      await new Promise((resolve) => setTimeout(resolve, 500));
      await refreshSideCart();
    }
  } catch (error) {
    console.error('Side cart promo sync error:', error);
  } finally {
    promoEngineRunning = false;
  }
}

function scheduleSideCartPromotionSync(delay = 900) {
  if (isCartPage()) return;

  clearTimeout(promoSyncTimer);
  promoSyncTimer = setTimeout(() => {
    syncPromotionsForSideCart();
  }, delay);
}

/* =========================
   THEME CODE
========================= */

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code !== 'undefined') {
      if (event.code.toUpperCase() !== 'TAB') return;
    }

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach(function(model) {
    if (model.modelViewerUI) {
      model.modelViewerUI.pause();
    }
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var option = document.createElement('option');
        option.value = provinces[i][0];
        option.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(option);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var option = document.createElement('option');
      option.value = values[i];
      option.innerHTML = values[i];
      selector.appendChild(option);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== 'undefined') {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove('overflow-hidden-mobile');
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) {
        this.closeMenuDrawer();
      }
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === 'undefined') {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-navigation-area');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.querySelector('.modal_back').addEventListener(
      'click',
      this.hide.bind(this)
    );

    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');

    if (this.querySelector('.template-popup') !== null) {
      this.querySelector('.template-popup').loadContent();
    }

    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (button !== null) {
      button.addEventListener('click', () => {
        if (document.querySelector(this.getAttribute('data-modal')) !== null) {
          document.querySelector(this.getAttribute('data-modal')).show(button);
        }
      });
    }
  }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if (this.querySelector('[id^="Deferred-Poster-"]') !== null) {
      this.querySelector('[id^="Deferred-Poster-"]').addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

